export default __webpack_public_path__ + "static/media/r13.825687d5.jpg";